import { useDynamicConfig } from "@statsig/react-bindings";
import { useMemo } from "react";

import {
  DEFAULT_ROUTINES_V2_CONFIG,
  ROUTINES_V2_CONFIG,
  type RoutinesV2Config,
  routinesV2ConfigSchema,
} from "@/types/routinesV2.ts";

/**
 * The account's `routines_v2` config, read the way the api's `getRoutinesV2`
 * reads it: the off default when no rule matches (Statsig answers `{}`) or the
 * dashboard value does not parse, so a bad value turns the work off rather than
 * on.
 */
export function useRoutinesV2(): Readonly<RoutinesV2Config> {
  const { value } = useDynamicConfig(ROUTINES_V2_CONFIG);
  return useMemo(() => {
    if (Object.keys(value).length === 0) return DEFAULT_ROUTINES_V2_CONFIG;
    const parsed = routinesV2ConfigSchema.safeParse(value);
    return parsed.success ? parsed.data : DEFAULT_ROUTINES_V2_CONFIG;
  }, [value]);
}
